/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Load_Preset_TitleInputs */



/**
* | output |
* | --- |
* | "Load a saved preset" |
*
* @param {Subtitle_Export_Load_Preset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_load_preset_title = /** @type {((inputs?: Subtitle_Export_Load_Preset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Load_Preset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger un préréglage enregistré")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine gespeicherte Voreinstellung laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica un preset salvato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузите сохраненный пресет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar un ajuste preestablecido guardado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载已保存的预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存したプリセットを読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक सहेजा हुआ प्रीसेट लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar uma predefinição salva")
	return /** @type {LocalizedString} */ ("Load a saved preset")
});